"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEvaluationResult = exports.isErrorType = exports.isCompleteType = exports.isClassificationProgress = void 0;
const isClassificationProgress = data => !!(data && typeof data === 'object' && 'total' in data && 'processed' in data);
exports.isClassificationProgress = isClassificationProgress;
const isEvaluationResult = data => !!(data && typeof data === 'object' && 'device_id' in data && 'matchInfo' in data && 'rules' in data && 'interfaces' in data);
exports.isEvaluationResult = isEvaluationResult;
const isCompleteType = data => !!(data && typeof data === 'object' && 'complete' in data && data.complete);
exports.isCompleteType = isCompleteType;
const isErrorType = data => !!(data && typeof data === 'object' && 'error' in data && data.error);
exports.isErrorType = isErrorType;